export const LangCodes = {
    zh_CN: 'zh_CN',
    fr: 'fr',
    ru: 'ru',
    ja: 'ja',
    zh_TW: 'zh_TW',
    it: 'it',
    ko: 'ko',
    pt_BR: 'pt_BR',
    da: 'da',
    de: 'de',
    fi: 'fi',
    es: 'es',
    en: 'en',
    sv: 'sv',
    pt_PT: 'pt_PT',
    nl: 'nl',
    no: 'no',
} as const;
export type LangCodesType = (typeof LangCodes)[keyof typeof LangCodes];

export type ServiceNames =
    | 'hp_cmsl'
    | 'hp_proactive_insights'
    | 'hp_protect_and_trace'
    | 'hp_protect_and_trace_trial_package'
    | 'hp_protect_and_trace_wolf_connect'
    | 'hp_poly'
    | 'hp_connect'
    | 'hp_command_center'
    | 'hp_care_pack'
    | 'ps_services_portal'
    | 'hp_raas'
    | 'employee_engagement'
    | 'hpcem'
    | 'hp_wolf_security';

export type IconInitials = {
    initials: string;
    textColor: string;
    bgColor: string;
    fillColor: string;
};

export type ServiceIcons = 'IconHome' | 'IconHandWithSquare' | 'IconTools' | 'IconPeople' | 'IconGear';

export type IconImage = {
    name: ServiceIcons;
};

export type IconMeta = IconInitials | IconImage;

export type TitleMeta = Record<LangCodesType, {name: string; value: string}>;

export type ToolMeta = {
    name: ServiceNames;
    appSites: string[];
    allowTrial: boolean;
    trialPlan: string;
    isVisibleToAppSwitcher: boolean;
    isVisibleToMyService: boolean;
    isVisibleToAllService: boolean;
    isVisibleToHelpSupport: boolean;
    isVisibleToLanding: boolean;
    isVisibleForTryIt: boolean;
    isFreeActiveService: boolean;
    launchUrl: string;
    displayName: TitleMeta;
    details: {
        detailsUrl: string;
        redirectUrls: null;
    };
    icon: IconMeta;
    isInternal: boolean;
    defaultOnboardingStatus: string;
    onboardUrl: string;
    description: TitleMeta;
    learnMoreLinks: {
        en: string;
    };
    imageLink: string;
};

export type ToolsMeta = {
    title: TitleMeta;
    services: ToolMeta[];
    icon: IconMeta;
};

export type LoginType = 'HPID' | 'AAD' | 'default';

export type RedirectUrls = Record<LoginType, string>;

export type Environments =
    | 'usdevms'
    | 'usperfms'
    | 'uspentestms'
    | 'usstagingms'
    | 'usprodms'
    | 'eudevms'
    | 'eustagingms'
    | 'euprodms';

export type CategoryService = {
    name: ServiceNames;
    appSites: string[];
    allowTrial: boolean;
    trialPlan?: string;
    isVisibleToAppSwitcher: boolean;
    isVisibleToMyService: boolean;
    isVisibleToAllService: boolean;
    isVisibleToHelpSupport: boolean;
    isVisibleToLanding: boolean;
    isVisibleForTryIt?: boolean;
    launchUrl: string;
    displayName: TitleMeta;
    details?: {
        detailsUrl: string;
        redirectUrls: null | (Partial<RedirectUrls> & {default: string});
    };
    icon: IconMeta;
    isInternal: boolean;
    defaultOnboardingStatus: string;
    onboardUrl?: string;
    description: TitleMeta;
    learnMoreLinks?: Partial<Record<LangCodesType, string>>;
    imageLink?: string;
    allowActivationEmail?: boolean;
    allowExpirationEmail?: boolean;
    baseDomains?: Partial<Record<Environments, string>> & {default: string};
};

export type CategoryMeta = {
    title: TitleMeta;
    services: CategoryService[];
    icon: IconMeta;
};

export type CatagoriesMeta = {
    [key: string]: CategoryMeta;
};

export type Tools = {
    [key: string]: ToolsMeta;
};

export type Config = {
    categories: CatagoriesMeta;
    tools: Tools;
};
